
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

export const useFilterOptions = (selectedRegion: string, selectedCountry: string) => {
  const [countryOptions, setCountryOptions] = useState<string[]>(["All"]);
  const [accountOptions, setAccountOptions] = useState<string[]>(["All"]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        let query = supabase.from('leaderboard').select('country');
        if (selectedRegion !== "All") {
          query = query.eq('region', selectedRegion);
        }
        const { data, error } = await query;
        if (error) {
          throw new Error(error.message);
        }
        const countries = data
          .map(item => item.country)
          .filter(country => country !== null && country !== undefined && country !== "") as string[];
        const uniqueCountries = [...new Set(countries)];
        setCountryOptions(["All", ...uniqueCountries.sort()]);
      } catch (err) {
        console.error("Error fetching country data:", err);
      }
    };
    fetchCountries();
  }, [selectedRegion]);

  useEffect(() => {
    const fetchAccountNames = async () => {
      try {
        let query = supabase.from('leaderboard').select('account_name');
        if (selectedRegion !== "All") {
          query = query.eq('region', selectedRegion);
        }
        if (selectedCountry !== "All") {
          query = query.eq('country', selectedCountry);
        }
        const { data, error } = await query;
        if (error) {
          throw new Error(error.message);
        }
        const accounts = data
          .map(item => item.account_name)
          .filter(account => account !== null && account !== undefined && account !== "") as string[];
        const uniqueAccounts = [...new Set(accounts)];
        setAccountOptions(["All", ...uniqueAccounts.sort()]);
      } catch (err) {
        console.error("Error fetching account data:", err);
      }
    };
    fetchAccountNames();
  }, [selectedRegion, selectedCountry]);

  return {
    countryOptions,
    accountOptions
  };
};
